import { Button } from "@/components/ui/button";
import { Calendar, Phone } from "lucide-react";

export function CtaBanner({ phone }: { phone?: string }) {
  const p = phone || "+977 1 412 3456";
  const clean = p.replace(/[\s\-\(\)]+/g, "");
  return (
    <section className="py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-primary p-10 text-primary-foreground md:p-16">
          <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-gold/20 blur-3xl" />
          <div className="absolute -bottom-32 -left-10 h-72 w-72 rounded-full bg-secondary/30 blur-3xl" />
          <div className="relative grid gap-8 md:grid-cols-[1.5fr_1fr] md:items-center">
            <div>
              <h2 className="font-display text-3xl font-semibold md:text-5xl">
                Your health, scheduled in <span className="italic text-gold">60 seconds</span>
              </h2>
              <p className="mt-4 max-w-xl text-primary-foreground/85">
                Choose a doctor, pick a time, confirm by SMS. No queues, no paperwork —
                just trusted care, ready when you are.
              </p>
            </div>
            <div className="flex flex-col gap-3 md:items-end">
              <Button size="lg" className="h-12 rounded-full bg-gold px-7 text-gold-foreground hover:opacity-90">
                <Calendar className="mr-2 h-4 w-4" /> Book Appointment
              </Button>
              <a href={`tel:${clean}`} className="flex items-center gap-2 text-sm text-primary-foreground/80 hover:text-gold">
                <Phone className="h-4 w-4" /> Or call {p}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
